import { render, staticRenderFns } from "./OrderLayoutRequests.vue?vue&type=template&id=d1112494&scoped=true"
import script from "./OrderLayoutRequests.vue?vue&type=script&lang=js"
export * from "./OrderLayoutRequests.vue?vue&type=script&lang=js"
import style0 from "./OrderLayoutRequests.vue?vue&type=style&index=0&id=d1112494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1112494",
  null
  
)

export default component.exports